/* Tur 23 EK10 film sistemi (Yapim-C). Veri tek kaynaktan (snippets/ag-c-filmler.liquid); bu dosya yalniz oynaticilar:
   - [data-ag-c-pf]  poster filmi (B070, B071, B072 ..., S098 kartlari, B032 film karti): poster once; video kaynagi ilk dokunusta
     eklenir (preload none), sessiz, dongu yok, bitince postere doner. Hareket azaltmada oynat dugmesi yok (CSS).
   - [data-ag-c-fd]  B091 "Bu parca filmde": alt panelde film, o andan sessiz; kapatinca durur, odak dugmeye doner.
   - [data-ag-c-kl]  S014 kumas klibi: galerinin 2. karesi; kare %60 gorunur olunca bir kez oynar, sonra posterde durur.
     Hareket azaltmada kendiliginden oynamaz (dugmeyle oynar). Oynat/durdur her zaman gorunur. */
(function () {
  if (window.AGFilmEk) return;
  window.AGFilmEk = true;
  var AZ = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function qa(s, k) { return [].slice.call((k || document).querySelectorAll(s)); }
  function kaynak(v) { if (!v.getAttribute('src')) v.setAttribute('src', v.getAttribute('data-src')); }
  function oynat(v, hata) { var p = v.play(); if (p && p.catch) p.catch(hata || function () {}); }

  /* Deneme modunda ?ag_tukendi=handle,handle: o urunlerin satirlari tukenmis gibi gizlenir; min3 filmde uctan az satir kalirsa film
     yuva adayi olmaktan cikar (sahne sirasi DOMContentLoaded'da secer; bu betik defer, ondan once calisir), liste3'te liste gizlenir. */
  (function () {
    var m = /[?&]ag_tukendi=([^&]+)/.exec(location.search);
    if (!m || !document.documentElement.classList.contains('ag-deneme')) return;
    var h = decodeURIComponent(m[1]).split(',');
    qa('[data-ag-c-pf-satir]').forEach(function (s) { if (h.indexOf(s.getAttribute('data-handle')) > -1) s.remove(); });
    qa('[data-ag-c-pf]').forEach(function (k) {
      var n = k.querySelectorAll('[data-ag-c-pf-satir]').length;
      if (k.hasAttribute('data-min3') && n < 3) { k.removeAttribute('data-ag-sahne-aday'); k.hidden = true; }
      if (k.hasAttribute('data-liste3') && n < 3) { var l = k.querySelector('[data-ag-c-pf-liste]'); if (l) l.hidden = true; }
    });
  })();

  function pf(kok) {
    var v = kok.querySelector('[data-ag-c-pf-video]'), b = kok.querySelector('[data-ag-c-pf-oynat]');
    if (!v || !b) return;
    var ad = b.getAttribute('aria-label');
    function durum(on) { kok.classList.toggle('is-oynuyor', on); b.setAttribute('aria-label', on ? 'Durdur' : ad); }
    b.addEventListener('click', function () {
      kaynak(v);
      if (v.paused) { oynat(v, function () { durum(false); }); durum(true); } else { v.pause(); durum(false); }
    });
    v.addEventListener('ended', function () { durum(false); v.load(); if (satir) isaretle(null); });
    if (!kok.hasAttribute('data-atla')) return;
    /* atla: satira ilk dokunus filmi o saniyeye goturur (oynatir), ayni satira ikinci dokunus urun sayfasina gider */
    var satir = qa('[data-ag-c-pf-satir]', kok), etkin = null;
    function isaretle(s) {
      etkin = s;
      satir.forEach(function (x) { var a = x.querySelector('a'); x.classList.toggle('is-etkin', x === s); if (a) { if (x === s) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); } });
    }
    satir.forEach(function (s) {
      s.querySelector('a').addEventListener('click', function (e) {
        if (s === etkin) return;
        e.preventDefault();
        kaynak(v);
        var sn = parseFloat(s.getAttribute('data-sn')) || 0;
        var git = function () { try { v.currentTime = sn; } catch (er) {} };
        if (v.readyState >= 1) git(); else v.addEventListener('loadedmetadata', git, { once: true });
        if (v.paused && !AZ) { oynat(v, function () { durum(false); }); durum(true); }
        isaretle(s);
      });
    });
    v.addEventListener('timeupdate', function () {
      if (v.paused) return;
      var t = v.currentTime, s = null;
      satir.forEach(function (x) { if (x.isConnected && (parseFloat(x.getAttribute('data-sn')) || 0) <= t + .05) s = x; });
      if (s && s !== etkin) isaretle(s);
    });
  }

  function fd(kok) {
    var dlg = kok.querySelector('[data-ag-c-fd-panel]'), v = kok.querySelector('[data-ag-c-fd-video]'), sn = parseFloat(kok.getAttribute('data-sn')) || 0, acan = null;
    if (!dlg || !v) return;
    function kapat() { v.pause(); if (dlg.open) dlg.close(); }
    qa('[data-ag-c-fd-izle]', kok).forEach(function (b) {
      b.addEventListener('click', function () {
        acan = kok.querySelector('.ag-c-fd__izle');
        kaynak(v);
        /* preload none: yukleme play() ile baslar; o an metaveri gelince basa (sn) atlanir */
        var atla = function () { try { v.currentTime = sn; } catch (e) {} };
        if (v.readyState >= 1) atla(); else v.addEventListener('loadedmetadata', atla, { once: true });
        oynat(v);
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      });
    });
    kok.querySelector('[data-ag-c-fd-kapat]').addEventListener('click', kapat);
    dlg.addEventListener('close', function () { v.pause(); if (acan) acan.focus({ preventScroll: true }); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) kapat(); });
  }

  function kl(kok) {
    var v = kok.querySelector('[data-ag-c-kl-video]'), b = kok.querySelector('[data-ag-c-kl-oynat]'), ciz = kok.querySelector('[data-ag-c-kl-cizgi]'), zm = kok.querySelector('[data-ag-c-kl-zaman]');
    if (!v || !b) return;
    var oynadi = false, ad = b.getAttribute('aria-label');
    function iki(x) { x = Math.floor(x || 0); return Math.floor(x / 60) + ':' + ('0' + x % 60).slice(-2); }
    function durum(on) { kok.classList.toggle('is-oynuyor', on); b.setAttribute('aria-label', on ? 'Durdur' : ad); }
    function bas() { kaynak(v); oynadi = true; oynat(v, function () { durum(false); }); durum(true); }
    b.addEventListener('click', function (e) { e.stopPropagation(); if (v.paused) bas(); else { v.pause(); durum(false); } });
    v.addEventListener('timeupdate', function () { var d = v.duration || 4; if (ciz) ciz.style.transform = 'scaleX(' + Math.min(1, v.currentTime / d) + ')'; if (zm) zm.textContent = iki(v.currentTime) + ' / ' + iki(d); });
    v.addEventListener('ended', function () { durum(false); v.load(); if (ciz) ciz.style.transform = 'scaleX(0)'; });
    if (AZ || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (g) { g.forEach(function (x) { if (x.isIntersecting && x.intersectionRatio >= .6 && !oynadi) { bas(); io.disconnect(); } }); }, { threshold: [.6] });
    io.observe(kok);
  }

  function hepsi() {
    qa('[data-ag-c-pf]').forEach(function (k) { if (!k.__ag) { k.__ag = 1; pf(k); } });
    qa('[data-ag-c-fd]').forEach(function (k) { if (!k.__ag) { k.__ag = 1; fd(k); } });
    qa('[data-ag-c-kl]').forEach(function (k) { if (!k.__ag) { k.__ag = 1; kl(k); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hepsi); else hepsi();
})();
